import Alerts from "./Alerts.web";
import { alertsQuery } from "./graphql";

export default alertsQuery(Alerts);
